<template>
  <layout-basic>
    <page-hero
      title="Develop Better Managers. Build Stronger Businesses."
      lead="Practical leadership programmes designed for growing organisations."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video video-key="leadership" />
      </v-container>
    </section>

    <section class="programmes-section">
      <v-container>
        <h2 class="font-sora programmes__title">Three programmes</h2>
        <div class="programmes">
          <article v-for="item in programmes" :key="item.title" class="programme-card">
            <h3 class="font-sora">{{ item.title }}</h3>
            <p>{{ item.body }}</p>
          </article>
        </div>
      </v-container>
    </section>

    <point-grid
      title="Optional ILM Accreditation"
      :points="points"
      :columns="2"
      tint
    />

    <v-container>
      <quote-block
        quote="Great businesses are built by great managers."
        attribution="Steve Walker, Founder"
      />
    </v-container>

    <standard-cta
      title="Build stronger leaders."
      lead="Watch the demo or experience IMPROVE and explore Leadership Plus for your managers."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import QuoteBlock from '@/components/marketing/QuoteBlock.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';
import { marketingPageMeta } from '@/utils/marketingPage';

export default {
  name: 'LeadershipPlus',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    QuoteBlock,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return marketingPageMeta({
      title: 'Leadership Plus | Develop Better Managers',
      description:
        'Practical leadership programmes for aspiring, first-line and senior managers, with optional ILM accreditation.',
      path: '/leadership-plus',
    });
  },
  data() {
    return {
      programmes: [
        {
          title: 'Aspiring Managers',
          body: 'Help high-potential employees build the foundations of people leadership before they step into the role.',
        },
        {
          title: 'First Line Managers',
          body: 'Practical skills for managers leading teams day to day—communication, performance, coaching and confidence.',
        },
        {
          title: 'Senior Managers & Directors',
          body: 'Develop experienced leaders who shape culture, strategy and stronger businesses.',
        },
      ],
      points: [
        'ILM-aligned programme options available',
        '50+ interactive leadership modules',
        'Bolt-on to any IMPROVE subscription',
        'Designed for growing organisations, not corporate complexity',
      ],
    };
  },
};
</script>

<style scoped>
.programmes-section {
  padding: 24px 0 8px;
}

.programmes__title {
  text-align: center;
  color: var(--brand-navy, #002458);
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 28px;
}

.programmes {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  max-width: 980px;
  margin: 0 auto;
}

.programme-card {
  background: #fff;
  border: 1px solid #e6ebf1;
  border-radius: 12px;
  padding: 22px 18px;
}

.programme-card h3 {
  color: var(--brand-navy, #002458);
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 10px;
}

.programme-card p {
  color: var(--brand-grey, #6b7280);
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

@media screen and (max-width: 900px) {
  .programmes {
    grid-template-columns: 1fr;
  }
}
</style>
